module.exports = __webpack_public_path__ + "media/images/bg/shapes/privacy-policy-5605712d6d437c7bf7749ff76275d052.svg";